import api from './api';
import {
  downloadVisitLetterPdfFromHtml,
  renderLetterPreviewHtml,
} from '../utils/visitLetterPdf';
import { normalizeLetterKind } from '../utils/visitLetterDisplay';

const visitLetterService = {
  async getList({ letterKind, projectCode, siteId, visitType }) {
    const params = {
      letterKind: letterKind || 'visit',
      projectCode: projectCode || undefined,
      siteId: siteId || undefined,
      visitType: visitType || undefined,
    };
    const response = await api.get('/visit-letters', { params });
    return response.data;
  },

  async getContent(letterKind, letterId) {
    const kind = letterKind || 'visit';
    const response = await api.get(`/visit-letters/${kind}/${letterId}/content`);
    return response.data;
  },

  async downloadPdf(letterKind, letterId, rowMeta = {}, options = {}) {
    const { projectCode, siteId } = options;
    const content = await this.getContent(letterKind, letterId);
    const header = content?.header ?? content?.Header ?? '';
    const body = content?.body ?? content?.Body ?? '';
    const footer = content?.footer ?? content?.Footer ?? '';
    const meta = content?.visitMeta ?? content?.VisitMeta ?? {};
    const visitCode = meta.displayVisitCode ?? meta.DisplayVisitCode
      ?? rowMeta.displayVisitCode ?? rowMeta.DisplayVisitCode ?? 'letter';
    const kind = normalizeLetterKind(letterKind || meta.letterKind || meta.LetterKind || 'visit');

    if (kind === 'piconfirmation') {
      const html = `<!DOCTYPE html><html><head><meta charset="utf-8"></head><body>${body || ''}</body></html>`;
      return downloadVisitLetterPdfFromHtml({
        html,
        fileName: `PI-Confirmation-${visitCode}.pdf`,
        title: 'PI Confirmation Letter',
      });
    }

    const prefix = kind === 'followup' ? 'Follow-Up-Letter' : 'Visit-Letter';
    const fileName = `${prefix}-${visitCode}.pdf`;

    const html = await renderLetterPreviewHtml({
      letterKind: kind,
      header,
      body,
      footer,
      visitMeta: meta,
      projectCode,
      siteId,
    });

    return downloadVisitLetterPdfFromHtml({
      html,
      fileName,
      title: prefix.replace(/-/g, ' '),
    });
  },
};

export default visitLetterService;
